module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer--top"
  }, [_c('div', {
    staticClass: "footer__container"
  }, [_c('div', {
    staticClass: "footer__row"
  }, [_vm._m(0), _c('div', {
    staticClass: "footer__item"
  }, [_c('div', {
    staticClass: "footer__button-group"
  }, [_c('a', {
    attrs: {
      "href": _vm.props.links.patient_links.patient_login,
      "target": "_blank"
    }
  }, [_vm._v("Patient Portal")]), _c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Make an Appointment")])], 1)]), _c('div', {
    staticClass: "footer__item"
  }, [_c('div', {
    staticClass: "footer__social-container"
  }, [_c('div', {
    staticClass: "footer__social-row"
  }, _vm._l((_vm.props.links.social_links), function(link) {
    return _c('a', {
      attrs: {
        "href": link.href,
        "target": "_blank"
      }
    }, [_c('Icon', {
      attrs: {
        "name": link.name
      }
    })], 1)
  }))])])])])]), _vm._m(1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__item"
  }, [_c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": "/wp-content/uploads/lovrovich-logo-temp.png",
      "alt": "Seattle Invisalign"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer--bottom"
  }, [_c('p', [_vm._v("© Copyright 2020 Lovrovich Orthodontics ")]), _c('p', [_vm._v("Online advantage by"), _c('a', {
    attrs: {
      "href": "https://www.roostergrin.com",
      "target": "_blank"
    }
  }, [_vm._v("Rooster Grin Media")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-385f7984","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 1113
// module chunks = 1